import { createFileRoute } from '@tanstack/react-router';
import { TransactionalSentDeliveryRoute } from '@/pages/workspaces/transactional/message/overview/sent/routing';

function TransactionalSentDeliveryRouteComponent() {
  const { transactionalMessageId, deliveryId } = Route.useParams();
  return <TransactionalSentDeliveryRoute transactionalMessageId={transactionalMessageId} deliveryId={deliveryId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId',
)({
  component: TransactionalSentDeliveryRouteComponent,
});
